import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';

import { setNavigate } from '@/core/api/api-client';
import { queryClient } from '@/core/api/query-client';
import { router } from './routes';

export function App() {
    useEffect(() => {
        setNavigate((path) => {
            router.navigate(path);
        });
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
        </QueryClientProvider>
    );
}
